import { withLegendRatio } from './setWithLegend';
import { getPieRadius } from '../../utils/chart';
import { textColor } from '../../theme/common/color';
export default function (chart, legend, theme) {
  var radius = getPieRadius(chart.radius);
  chart.labelLine.normal.show = true;
  chart.label.normal.show = true;
  chart.radius[1] = '50%';

  if (legend) {
    chart.radius[1] = 50 / withLegendRatio + "%";
  }

  chart.data.forEach(function (item, idx) {
    item.label = {
      normal: {
        formatter: '{name|{b}}\n{hr|}\n{value|{c}}',
        rich: {
          name: {
            align: 'left',
            padding: 4,
            color: textColor.gray
          },
          hr: {
            width: '100%',
            height: 1,
            backgroundColor: theme.color[idx]
          },
          value: {
            align: 'left',
            padding: 4,
            color: textColor.normal
          }
        }
      }
    };
  });
}